<template>
  <v-dialog
    :value="showDialog"
    @click:outside="closeDialog"
    max-width="675px"
    tile
  >
    <v-app-bar
      class="primary"
      height="45"
    >
      <div class="d-flex align-center justify-space-between">
        <p class="white--text text-body-1 text-uppercase mb-0" v-if="dialogHeader">
          {{ dialogHeader || '' }}
        </p>
        <v-btn
          icon
          class="closeDialog white--text"
          :ripple="false"
          small
          rounded
          fab
          style="right: 12px"
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-card
      tile
    >
      <v-card-text
        class="pl-7 pr-6 pt-9 text-left"
      >
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CardInfoDialog",
  props: {
    showDialog: Boolean,
    dialogHeader: String,
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-dialog {
  overflow: hidden;

  .closeDialog {
    position: absolute;
    right: 0;
  }
}
</style>
